import { render } from "./UserPanel.vue?vue&type=template&id=3f7c6c18&scoped=true"
import script from "./UserPanel.vue?vue&type=script&lang=js"
export * from "./UserPanel.vue?vue&type=script&lang=js"

import "./UserPanel.vue?vue&type=style&index=0&id=3f7c6c18&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7c6c18"]])

export default __exports__